module.exports = __webpack_public_path__ + "static/media/baseMeme15.6951ea4d.jpg";